import axiosInstance from '../helpers/axiosInstance'

const BASE = process.env.REACT_APP_PLATFORM_URL

export const fetchSalesChannels = async params => {
  const res = await axiosInstance.get(`${BASE}/api/v1/sales_channels`, { params })
  return res.data
}

export const fetchSalesChannel = async id => {
  const res = await axiosInstance.get(`${BASE}/api/v1/sales_channels/${id}`)
  return res.data
}

export const createSalesChannel = async data => {
  const res = await axiosInstance.post(`${BASE}/api/v1/sales_channels`, data)
  return res.data
}

export const updateSalesChannel = async (id, data) => {
  const res = await axiosInstance.patch(`${BASE}/api/v1/sales_channels/${id}`, data)
  return res.data
}

export const disableSalesChannel = async id => {
  const res = await axiosInstance.delete(`${BASE}/api/v1/sales_channels/${id}`)
  return res.data
}

export const restoreSalesChannel = async id => {
  const res = await axiosInstance.patch(`${BASE}/api/v1/sales_channels/${id}/restore`)
  return res.data
}

export const fetchSalesChannelHistory = async (id, params) => {
  const res = await axiosInstance.get(`${BASE}/api/v1/sales_channels/${id}/history`, { params })
  return res.data
}
